/**
 * Application Process 1030 — BDU Admission Process
 * Centred heading with a gradient rule, then a wrapping row of numbered step cards.
 *
 * `application_process` has no `metadata` column, so the steps are stored in
 * `metadata_1` (variant 2 uses `metadata_2` for the same reason).
 */

export const APPLICATION_PROCESS_1030_CONSTANTS = {
  METADATA_TITLES: {
    metadata_1: "Steps",
  },

  DEFAULT_ROW_1: {
    id: "1",
    meta_title: "Register Online",
    meta_description:
      "Register on the University admission portal and complete the online admission form for your chosen programme.",
    meta_priority: 1,
    meta_status: true,
  },

  APPLICATION_PROCESS_FIELDS_CONFIG: [
    {
      fieldName: "title",
      label: "Heading",
      value: "Admission process",
      valueType: "string",
      filedType: "INPUT",
      defaultValue: "Admission process",
    },
    {
      fieldName: "title_start_color",
      label: "Heading colour",
      value: "#000000",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#000000",
    },
    {
      fieldName: "desktop_background_color",
      label: "Section background",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "e.g. #FFFFFF",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "gradient_color_1",
      label: "Rule under heading — start",
      value: "#1F3D56",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#1F3D56",
    },
    {
      fieldName: "gradient_color_2",
      label: "Rule under heading — end",
      value: "#7CB5E6",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#7CB5E6",
    },
    {
      fieldName: "accent_color",
      label: "Step number ring + digit",
      value: "#000000",
      valueType: "string",
      filedType: "COLOR",
      defaultValue: "#000000",
    },
    {
      fieldName: "status",
      label: "Section status",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      defaultValue: true,
    },
  ],

  METADATA_FIELDS_1: [
    {
      header: "Step title",
      fieldName: "meta_title",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      defaultValue: "",
    },
    {
      header: "Step description",
      fieldName: "meta_description",
      value: "",
      valueType: "string",
      filedType: "TEXT_AREA",
      defaultValue: "",
      rows: 3,
    },
    {
      header: "Priority",
      fieldName: "meta_priority",
      value: 1,
      valueType: "number",
      filedType: "INPUT",
      defaultValue: 1,
    },
    {
      header: "Status",
      fieldName: "meta_status",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      defaultValue: true,
    },
  ],
};
